import request from '../../utils/request';

// для теста загрузки видео в dev-режиме
// const API_PATH = 'https://medialib-open-api.life.ru/api/v1';

const API_PATH = '/_api/medialib/v1';

export function postItems({ prefix, upload } = {}) {
  const url = `${API_PATH}/items`;

  const data = new FormData();

  if (prefix) {
    data.append('prefix', prefix);
  }

  const uploads = (!(upload instanceof FileList || Array.isArray(upload))) ? [upload] : upload;

  for (let i = 0; i < uploads.length; i += 1) {
    if (uploads[i] instanceof File) {
      data.append('upload', uploads[i]);
    }
  }

  return request(url, {
    method: 'POST',
    credentials: 'include',
    body: data,
  });
}

export function patchItem({ id, attributes } = {}) {
  const url = `${API_PATH}/items/${id}`;

  return request(url, {
    method: 'PATCH',
    credentials: 'include',
    body: JSON.stringify({
      data: { type: 'items', id, attributes },
    }),
  });
}
